import { st } from "../../styles.js";
import { BuzerIcon } from "../../BuzerIcons";
import { BADGE_ICON } from "../../BadgeIcons";
import { ProgressBar, SectionHeader } from "./ds";
import { badgeProgressPct, closestBadgeCode } from "../../lib/badges";

// v26 §2 — odznaky zoskupené po kategóriách, s progresom k ďalšiemu tieru
const CAT_LABELS = {
  splnenia: "Splnenia", seria: "Séria", body: "Body", vyzvy: "Výzvy",
  priatelia: "Priatelia", nalady: "Nálady", planovanie: "Plánovanie",
  // v32 — koľko rôznych životných kategórií zvládne človek pokryť v jeden deň
  rovnovaha: "Rovnováha",
  // v35 — kategória obsahuje aj strieborné/zlaté týždne (týždenná konzistencia), nielen perfektné
  tyzdne: "Týždne", vernost: "Vernosť", special: "Špeciálne",
};
// v26.2 §6 — „sutaze" zlúčené pod „vyzvy"; ponechané vo fallbacku pre staré payloady
const CAT_ORDER = ["splnenia", "seria", "body", "vyzvy", "sutaze", "priatelia", "nalady", "planovanie", "rovnovaha", "tyzdne", "vernost", "special"];

function badgeBtn(b, onPick, pct) {
  const counter = b.target != null && b.value != null ? ` (${b.value}/${b.target})` : "";
  return (
    <button key={b.code} type="button" onClick={() => onPick && onPick(b)} title={b.name + " — " + b.desc + counter}
      data-badge={b.code}
      data-tour={b.code === "tutorial" ? "badge-tutorial" : undefined}
      /* v27 §4 — Mali: per-dlaždicový grayscale filter na ~50 zamknutých odznakoch spúšťal glitch; na Androide len opacity */
      style={{ ...st.badgeItem, ...(b.earned ? {} : st.badgeLocked), font: "inherit", color: "inherit", cursor: onPick ? "pointer" : "default" }}>
      <span style={st.badgeIcon}>{b.earned ? <BuzerIcon name={BADGE_ICON[b.code] || "trophy"} size={26} color="var(--text)" /> : <BuzerIcon name="lock" size={22} color="var(--muted)" />}</span>
      <span style={st.badgeName}>{b.name}</span>
      {pct != null && <ProgressBar size="sm" pct={pct} className="bz-badge-prog" />}
    </button>
  );
}

// v32 — zdieľaná karta „Odznaky x/y" (Prehľad + verejný profil): ZÍSKANÉ odznaky v plochej
// mriežke v boxe, mono-uppercase hlavička s počtom. `trailing` = voliteľný prvok vpravo
// v hlavičke (v Prehľade „Všetky"), `scrollId` = data-scroll kotva, `emptyText` = text bez odznakov.
export function EarnedBadgesCard({ badges, onPick, trailing, scrollId, emptyText, flat }) {
  const total = (badges || []).length;
  if (!total) return null;
  const earned = badges.filter((b) => b.earned);
  // v33h — `flat` (verejný profil): bez orámovaného boxu (levelBox), odznaky ležia priamo v sekcii;
  // ostáva len orámovanie samotných odznakov. Inde (Prehľad) ostáva box.
  const grid = earned.length > 0
    ? <BadgeGrid badges={earned.map((b) => ({ ...b, cat: null }))} onPick={onPick} />
    : (emptyText ? <div style={{ ...st.taskDesc, padding: "4px 0" }}>{emptyText}</div> : null);
  return (<>
    {/* v32 — bez slova „Odznaky" (kontext dáva sekcia/karta), len počet x/y */}
    <div style={st.ovGroupRow} data-scroll={scrollId}>
      <span className="bz-sectlabel">{earned.length}/{total}</span>
      {trailing}
    </div>
    {flat
      ? <div style={{ marginBottom: 22 }}>{grid}</div>
      : <div style={{ ...st.levelBox, cursor: "default", marginBottom: 22 }}>{grid}</div>}
  </>);
}

export function BadgeGrid({ badges, onPick }) {
  if (!badges || !badges.length) return null;
  if (!badges.some((b) => b.cat)) {
    // fallback pre payload bez kategórií (napr. verejný profil / EarnedBadgesCard).
    // v33h — BadgeGrid VŽDY vlastní PRÁVE JEDNU GPU vrstvu (aj vo `flat` verejnom profile, kde
    // niet levelBoxu); levelBox už translateZ nemá → žiadne vnorené vrstvy = žiadny Mali glitch.
    const nextCode = closestBadgeCode(badges);
    return <div style={{ transform: "translateZ(0)", backfaceVisibility: "hidden" }}>
      <div style={st.badgeGrid}>{badges.map((b) => badgeBtn(b, onPick, b.code === nextCode ? badgeProgressPct(b) : null))}</div></div>;
  }
  const byCat = {};
  for (const b of badges) (byCat[b.cat || "vernost"] = byCat[b.cat || "vernost"] || []).push(b);
  return (
    <div style={{ transform: "translateZ(0)", backfaceVisibility: "hidden" }}>  {/* v26.2 §2 + v27 §4 — own GPU layer, plný v18 vzor (Mali fix) */}
      {CAT_ORDER.filter((c) => byCat[c]).map((c) => {
        const items = byCat[c].slice().sort((a, b) => (a.tier || 0) - (b.tier || 0));
        const earnedN = items.filter((b) => b.earned).length;
        const nextCode = closestBadgeCode(items);   // v36 — jeden prúžok na kategóriu
        return (
          <div key={c} style={{ marginBottom: 4 }}>
            {/* v34 — rovnaká hlavička ako Archív návykov: label → hairline → počet vpravo (SectionHeader) */}
            <SectionHeader label={CAT_LABELS[c] || c} count={`${earnedN}/${items.length}`} style={{ margin: "14px 2px 6px" }} />
            <div style={st.badgeGrid}>{items.map((b) => badgeBtn(b, onPick, b.code === nextCode ? badgeProgressPct(b) : null))}</div>
          </div>
        );
      })}
    </div>
  );
}
